<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <h1>Inline Quality Checks</h1>
        <v-text-field
          filled
          data-cy="FormInLineQualityCheck-deliveryDate"
          :label="$$t('deliveryDate')"
          v-model="localInLineQualityCheck.deliveryDate"
        />
        <v-text-field
          filled
          data-cy="FormInLineQualityCheck-farm"
          :label="$$t('farm')"
          v-model="localInLineQualityCheck.farm"
        />
        <v-text-field
          filled
          data-cy="FormInLineQualityCheck-sizeRange"
          :label="$$t('sizeRange')"
          v-model="localInLineQualityCheck.sizeRange"
        />
        <v-select
          v-model="localInLineQualityCheck.shuckingDamagePoorTechnique"
          :items="['Yes', 'No']"
          :label="$$t('shuckingDamagePoorTechnique')"
        ></v-select>
        <v-select
          v-model="localInLineQualityCheck.shuckingDamagePoorProduct"
          :items="['Yes', 'No']"
          :label="$$t('shuckingDamagePoorProduct')"
        ></v-select>
        <SelectGutsRemoved
          v-model="localInLineQualityCheck.shuckingGutsRemovedProperly"
          :label="$$t('shuckingGutsRemovedProperly')"
        />
        <SelectGutsRemoved
          v-model="localInLineQualityCheck.generalQuality"
          :label="$$t('generalQuality')"
        />
        <v-text-field
          filled
          data-cy="FormInLineQualityCheck-shuckingComments"
          :label="$$t('shuckingComments')"
          v-model="localInLineQualityCheck.shuckingComments"
        />
        <InlineQualityCheckSampleItems
          title="Beak Cutting Quality Checks"
          :sizeRange="localInLineQualityCheck.sizeRange"
          :items="[
            'beakCuttingDamagePoorTechnique',
            'beakCuttingGutsRemovedProperly',
            'beakCuttingOtherComments',
          ]"
        />
        <v-text-field
          filled
          data-cy="FormInLineQualityCheck-beakCuttingComments"
          :label="$$t('beakCuttingComments')"
          v-model="localInLineQualityCheck.beakCuttingComments"
        />
        <hr class="mb-5 mt-5" />
        <SignVerification role="Operator" title="Verified by"
            v-model="localInLineQualityCheck.verifiedBySignature" />
        <br />
        <v-row>
          <v-col cols="12" class="mb-10">
            <v-btn block color="success" @click="handover('Ready for NRCS')">Handover</v-btn>
          </v-col>
        </v-row>
        <InlineQualityCheckSampleItems
          title="Scrubbing Quality Checks"
          :sizeRange="localInLineQualityCheck.sizeRange"
          :items="[
            'scrubbingAnimalsClean',
            'scrubbingGutsRemovedProperly',
            'scrubbingForeignMatter',
            'scrubbingDamagedAnimals',
          ]"
        />
        <hr class="mb-5 mt-5" />
        <SignVerification role="Operator" title="Verified by"
            v-model="localInLineQualityCheck.verifiedBySignature" />
        <br />
        <v-row>
          <v-col cols="12" class="mb-10">
            <v-btn block color="success" @click="handover('Ready for NRCS')">Handover</v-btn>
          </v-col>
        </v-row>
        <v-text-field
          filled
          data-cy="FormInLineQualityCheck-scrubbingComments"
          :label="$$t('scrubbingComments')"
          v-model="localInLineQualityCheck.scrubbingComments"
        />
        <InlineQualityCheckSampleItems
          title="Blanching Temp Checks"
          :sizeRange="localInLineQualityCheck.sizeRange"
          :items="[
            'preBlanchingMeatTemp',
            'blanchingHotWaterTemp',
            'blanchingColdWaterTemp',
          ]"
        />
        <v-text-field
          filled
          data-cy="FormInLineQualityCheck-blanchingComments"
          :label="$$t('blanchingComments')"
          v-model="localInLineQualityCheck.blanchingComments"
        />
        <hr class="mb-5 mt-5" />
        <SignVerification role="Operator" title="Verified by"
            v-model="localInLineQualityCheck.verifiedBySignature" />
        <br />
        <v-row>
          <v-col cols="12" class="mb-10">
            <v-btn block color="success" @click="handover('Ready for NRCS')">Handover</v-btn>
          </v-col>
        </v-row>
        <InlineQualityCheckSampleItems
          title="Pre-Canning Quality Checks"
          :sizeRange="localInLineQualityCheck.sizeRange"
          :items="[
            'preCanningAnimalsClean',
            'preCanningDamagedAnimals',
            'preCanningCracking',
            'scrubbingDamagedAnimals',
          ]"
        />
        <v-text-field
          filled
          data-cy="FormInLineQualityCheck-preCanningComments"
          :label="$$t('preCanningComments')"
          v-model="localInLineQualityCheck.preCanningComments"
        />
        <hr class="mb-5 mt-5" />
        <SignVerification role="Operator" title="Verified by"
            v-model="localInLineQualityCheck.verifiedBySignature" />
        <br />
        <v-row>
          <v-col cols="12" class="mb-10">
            <v-btn block color="success" @click="handover('Ready for NRCS')">Handover</v-btn>
          </v-col>
        </v-row>
        <InlineQualityCheckSampleItems
          title="Canning Quality Checks"
          :sizeRange="localInLineQualityCheck.sizeRange"
          :items="[
            'packedCanScratched',
            'packedCorrect',
            'packedDamagedAnimals',
            'packedIngoWithinLimits',
            'packedCorrectPieceCount',
          ]"
        />
        <v-text-field
          filled
          data-cy="FormInLineQualityCheck-packedComments"
          :label="$$t('packedComments')"
          v-model="localInLineQualityCheck.packedComments"
        />
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormInLineQualityCheck-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormInLineQualityCheck-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import InlineQualityCheckSampleItems from './InlineQualityCheckSampleItems.vue';
import SelectGutsRemoved from './SelectGutsRemoved.vue';
import SignVerification from './SignVerification.vue';

export default {
  name: 'FormInLineQualityCheck',
  module: 'InLineQualityCheck',
  components: {
    InlineQualityCheckSampleItems,
    SelectGutsRemoved,
    SignVerification,
  },
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    InLineQualityCheck: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localInLineQualityCheck
      */
      localInLineQualityCheck: {},
    };
  },
  watch: {
    InLineQualityCheck() {
      this.localInLineQualityCheck = this.InLineQualityCheck;
    },
  },
  created() {
    this.localInLineQualityCheck = this.InLineQualityCheck;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    handover(status) {
      this.localInLineQualityCheck.status = status;
      this.$emit('save', this.localInLineQualityCheck);
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localInLineQualityCheck);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormInLineQualityCheck example

'''js
<FormInLineQualityCheck :InLineQualityCheck="InLineQualityCheck" />
'''
</docs>
